import {httpGetPlannedAccesses} from '@/features/planned-accesses/http/plannedAccesses.http'
import {ProjectPlannedAccess} from '@/features/planned-accesses/types'
import {QUERY_KEYS} from '@/queryClient'
import {ErrorResponseData} from '@/types'
import {useQuery, UseQueryOptions} from '@tanstack/react-query'
import {AxiosError} from 'axios'

interface UseGetPlannedAccessesOptions {
    urlParams: {
        projectId: string
    }
    options?: Omit<UseQueryOptions<ProjectPlannedAccess, AxiosError<ErrorResponseData>>, 'queryKey' | 'queryFn'>
}

export const useGetPlannedAccesses = ({urlParams, options}: UseGetPlannedAccessesOptions) =>
    useQuery({
        queryKey: [QUERY_KEYS.PLANNED_ACCESSES, urlParams.projectId],
        queryFn: () =>
            httpGetPlannedAccesses({
                urlParams
            }),
        ...options
    })
